import React from 'react';
import type { FC } from 'react';
import { createContext, useContext } from 'react';
import type { Updater } from 'use-immer';
import { useImmer } from 'use-immer';

export function createImmerContext<T>(createDefaultState: () => T) {
  const ImmerContext = createContext<[T, Updater<T>]>([createDefaultState(), () => {}]);

  const ImmerProvider: FC = ({ children }) => {
    const stateAndUpdate = useImmer<T>(createDefaultState());
    return <ImmerContext.Provider value={stateAndUpdate}>{children}</ImmerContext.Provider>;
  };

  const useImmerContext = () => {
    return useContext(ImmerContext);
  };

  return [ImmerProvider, useImmerContext] as const;
}
